var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync 1",
    clipPath: "url(#clip0_1796_12681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 2.36253V4.85625C14 5.3395 13.6082 5.73125 13.125 5.73125H10.6313C10.148 5.73125 9.75628 5.3395 9.75628 4.85625C9.75628 4.373 10.148 3.98125 10.6313 3.98125H11.2998C10.3336 2.59643 8.75019 1.75 7 1.75C4.82237 1.75 2.90259 3.06012 2.10913 5.08766C1.93298 5.53768 1.42537 5.75969 0.975406 5.58359C0.525383 5.40747 0.303352 4.89989 0.479473 4.44989C0.986945 3.15317 1.86162 2.04621 3.00893 1.24868C4.18409 0.431785 5.56415 0 7 0C8.43585 0 9.81591 0.431785 10.9911 1.24865C11.458 1.57322 11.8798 1.94909 12.25 2.36811V2.36255C12.25 1.87931 12.6418 1.48755 13.125 1.48755C13.6082 1.48755 14 1.87928 14 2.36253ZM13.0246 8.41643C12.5746 8.24028 12.067 8.46237 11.8909 8.91237C11.0974 10.9399 9.17763 12.25 7 12.25C5.287 12.25 3.73368 11.4391 2.76254 10.1062H3.36872C3.85197 10.1062 4.24372 9.7145 4.24372 9.23125C4.24372 8.748 3.85197 8.35625 3.36872 8.35625H0.875C0.391754 8.35625 0 8.748 0 9.23125V11.725C0 12.2082 0.391754 12.6 0.875 12.6C1.35825 12.6 1.75 12.2082 1.75 11.725V11.6319C2.12023 12.0509 2.54201 12.4268 3.00893 12.7513C4.18409 13.5682 5.56415 14 7 14C8.43585 14 9.81591 13.5682 10.9911 12.7513C12.1384 11.9538 13.0131 10.8469 13.5205 9.55013C13.6966 9.10014 13.4746 8.59255 13.0246 8.41643Z",
    fill: "#F5D016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1796_12681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSync);
export default __webpack_public_path__ + "static/media/icon_sync.09336eac1dd6bc6c4bed4cfb3a6b6f60.svg";
export { ForwardRef as ReactComponent };